import React from 'react';
import {View} from 'react-native';

import Icon from '/component/base/Icon';
import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {withHOC} from '/util/hoc.util';

import {styles} from './DiscreteProgressListItem.style';

interface DiscreteProgressListItemProps {
  currentCount: number | null;
  getTheme: (key: string) => string;
  label: string;
  onPress: () => void;
  readonly: boolean;
  style: {
    textWrapper: {};
    suffix: {};
  };
  targetCount: number | null;
}

export const DiscreteProgressListItem: React.FC<
  DiscreteProgressListItemProps
> = ({
  currentCount,
  getTheme,
  label,
  onPress,
  readonly,
  style: styleProp = {textWrapper: {}, suffix: {}},
  targetCount,
}) => {
  const color = getTheme('competency.backgroundColor.backgroundColor');
  const radioIconStyles = {...styles.icon, color};
  const iconsArray = [];

  for (let i = 0; i < (targetCount ?? 0); i++) {
    i < (currentCount ?? 0)
      ? iconsArray.push({name: 'radio', style: radioIconStyles})
      : iconsArray.push({name: 'circle-filled', style: styles.icon});
  }

  return (
    <ListItem
      onPress={onPress}
      readonly={readonly}
      label={
        <View style={{...styles.textWrapper, ...(styleProp.textWrapper || {})}}>
          <Text>{label}</Text>
        </View>
      }
      suffix={
        <View style={{...styles.suffix, ...(styleProp.suffix || {})}}>
          <View style={styles.iconWrapper}>
            {iconsArray.map(({name, style}, index) => (
              <Icon style={style} name={name} key={`${name}-${index}`} />
            ))}
          </View>
          <Text variant="button">
            {currentCount}/{targetCount}
          </Text>
        </View>
      }
      style={{base: {paddingVertical: 20}}}
    />
  );
};

export const UnwrappedDiscreteProgressListItem = DiscreteProgressListItem;

export default withHOC(withTheme, withCompetency)(DiscreteProgressListItem);
